import type { FetchResponse, Interceptor } from '@sydle/ui-api';
import { FeedbackChannels } from '../../components/forms/one-draft-form/feedback-services/draft-feedback.service.types';
import { DraftMethods } from '../draft-api';
import { MessageDraftServerService } from '../../components/forms/one-draft-form/feedback-services/message-draft-server.service';
import { extractInfosByURL, removeQueryParams } from '../utils/url';
import { FormMethods } from '../form-api';

export class DraftFeedbackInterceptor implements Interceptor {
  interceptorResponse = async (response: FetchResponse, isCompletedURL): Promise<any> => {
    const { objectId, methodIdentifier } = this.extractObjectIdAndMethodIdentifierFromResponse(
      response,
      isCompletedURL,
    );
    const draftChannel = this.getFeedbackChannelByMethod(methodIdentifier);

    if (draftChannel) {
      const draftId = objectId;

      const messagesReference = response?.error?.data?._messages || response?.data?._messages || [];

      const filteredMessages = MessageDraftServerService.filterMessageByDraftId(
        messagesReference,
        draftId,
        draftChannel,
        methodIdentifier,
      );

      if (response?.error?.data?._messages) {
        response.error.data._messages = filteredMessages;
      } else if (response?.data?._messages) {
        response.data._messages = filteredMessages;
      }
    }
    return response;
  };

  private getFeedbackChannelByMethod(methodIdentifier: string): FeedbackChannels {
    const rawMethodIdentifier = removeQueryParams(methodIdentifier);

    if (this.isSpecificMethod(rawMethodIdentifier, DraftMethods.PUBLISH)) {
      return FeedbackChannels.PUBLISH;
    }
    if (this.isSpecificMethod(rawMethodIdentifier, FormMethods.PATCH)) {
      return FeedbackChannels.UPDATE;
    }
    return;
  }

  private extractObjectIdAndMethodIdentifierFromResponse(
    response: FetchResponse,
    isCompletedURL: boolean,
  ): { objectId: string; methodIdentifier: string } {
    let objectId = '';
    let methodIdentifier = '';

    const infosFromURL = extractInfosByURL(response.meta.request.url, isCompletedURL);

    // Define objectId and methodIdentifier based on request method.
    if (response.meta.request.method === 'POST') {
      objectId = response.meta.requestParams.body?.reference?._id;
      methodIdentifier = infosFromURL.methodIdentifier;

      if (methodIdentifier === DraftMethods.PUBLISH) {
        objectId = infosFromURL.objectId;
      }
    } else {
      objectId = infosFromURL.objectId;
      methodIdentifier = infosFromURL.methodIdentifier;
    }

    return { objectId, methodIdentifier };
  }

  private isSpecificMethod(methodIdentifier: string, searchMethod): boolean {
    return methodIdentifier && methodIdentifier.indexOf(searchMethod) !== -1;
  }
}
